import { toast } from 'react-toastify';

export function showToast(message: string, type: 'info' | 'success' | 'warning' | 'error' = 'info') {
  toast[type](message, {
    position: "bottom-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });
}

export function toggleIframeVisibility(setIsIframeVisible: React.Dispatch<React.SetStateAction<boolean>>) {
  setIsIframeVisible(prev => !prev);
}

export function showPopupIframe(setIsIframeVisible: React.Dispatch<React.SetStateAction<boolean>>) {
  setIsIframeVisible(true);
}

export function hideIframe(setIsIframeVisible: React.Dispatch<React.SetStateAction<boolean>>) {
  setIsIframeVisible(false);
}

export function maximizeIframe(setIsIframeMaximized: React.Dispatch<React.SetStateAction<boolean>>) {
  setIsIframeMaximized(true);
}

export function restoreIframe(setIsIframeMaximized: React.Dispatch<React.SetStateAction<boolean>>) {
  setIsIframeMaximized(false);
}

export function sendMessageToIframe(iframeRef: React.RefObject<HTMLIFrameElement>, message: any) {
  if (iframeRef.current && iframeRef.current.contentWindow) {
    iframeRef.current.contentWindow.postMessage(message, '*');
  } else {
    console.error('Iframe reference not available');
  }
}

export function updatePopupIframeSrc(setIframeSrc: (src: string) => void, iframeRef: React.RefObject<HTMLIFrameElement>, newSrc: string) {
  setIframeSrc(newSrc);
  if (iframeRef.current) {
    iframeRef.current.src = newSrc;
  }
}

export function showBot(sendMsgToBot: (msg: string) => void, setBotDisplayStatusSession: (value: string) => void) {
  sendMsgToBot('maximize');
  setBotDisplayStatusSession('open');
  window.sessionStorage.setItem('botDisplayStatusSession', 'open');
  const chatContainer = document.getElementById('chatContainer') as HTMLElement;
  if (chatContainer) {
    chatContainer.style.display = 'inline';
  }
}

export function hideBot(setBotDisplayStatusSession: (value: string) => void) {
  setBotDisplayStatusSession('closed');
  window.sessionStorage.setItem('botDisplayStatusSession', 'closed');
  const chatContainer = document.getElementById('chatContainer') as HTMLElement;
  if (chatContainer) {
    chatContainer.style.display = 'none';
  }
}

export function toggleChatbot(botDisplayStatusSession: string, showBot: () => void, hideBot: () => void) {
  if (botDisplayStatusSession === 'open') {
    hideBot();
  } else {
    showBot();
  }
}

export function mapCommand(
  command: string, 
  hideBot: () => void, 
  showBot: () => void,
  minimizeChatbot?: () => void,
  maximizeChatbot?: () => void
) {
  console.log('mapCommand received:', command);
  
  // Extract actual command from various formats:
  // 1. "mapCommand:minimize" -> "minimize"
  // 2. 'mapCommand("hideBot")' -> "hideBot"
  // 3. "mapCommand('minimize')" -> "minimize"
  // 4. "minimize" -> "minimize"
  let actualCommand = command;
  
  if (command.includes('mapCommand(')) {
    // Format: mapCommand("hideBot") or mapCommand('hideBot')
    const match = command.match(/mapCommand\(['"]([^'"]+)['"]\)/);
    if (match && match[1]) {
      actualCommand = match[1];
    }
  } else if (command.includes(':')) {
    // Format: mapCommand:minimize
    actualCommand = command.split(':')[1];
  }
  
  console.log('Parsed command:', actualCommand);
  
  if ('hideBot' === actualCommand || 'hide' === actualCommand || 'minimize' === actualCommand) {
    console.log('Executing hideBot/minimize');
    if (minimizeChatbot) {
      minimizeChatbot();
    } else {
      hideBot();
    }
  } else if ('showBot' === actualCommand || 'show' === actualCommand || 'maximize' === actualCommand) {
    console.log('Executing showBot/maximize');
    if (maximizeChatbot) {
      maximizeChatbot();
    } else {
      showBot();
    }
  } else {
    console.log('Unknown command:', actualCommand);
  }
} 